import { Breakpoints, Container, ContainerGutter, ContainerPadding, CTA, Text, TokenTextAppearance, ThemeProvider } from '@volkswagen-onehub/components-core';
import React from 'react';
import './RecallLayer.scss';
import { Modal } from '../../models/Modal';
import { Recalls } from '../../models/Recalls';
import { DataRequestState } from '../../models/DataRequestState';

export default function RecallLayer({ close, state }: Modal<RecallLayerProps>) {
	const { recalls, t } = state;

	if (recalls.state !== DataRequestState.Available) {
		return <></>;
	}

	return (
		<ThemeProvider theme="main">
			<Container wrap="always" gutter={ContainerGutter.dynamic0100} padding={{ left: ContainerPadding.grid002, right: ContainerPadding.grid002 }}>
				<Text appearance={TokenTextAppearance.headline400}>
					{recalls.data.length === 1 ? t('recalls.titleOneRecall') : t('recalls.titleMultipleRecalls')}
				</Text>

				{recalls.data.map((recall) => (
					<Container wrap="always" gutter={ContainerGutter.dynamic0020}>
						<Text appearance={TokenTextAppearance.headline200} bold>
							{recall.title}
						</Text>

						<Text appearance={TokenTextAppearance.copy200} className="recall-description">
							{recall.description}
						</Text>
					</Container>
				))}

				<CTA
					tag="button"
					emphasis="secondary"
					key="close Recall Layer"
					onClick={close}
					stretchContent={{ [Breakpoints.default]: true, [Breakpoints.b560]: false }}
				>
					{t('general.close')}
				</CTA>
			</Container>
		</ThemeProvider>
	);
}

export interface RecallLayerProps {
	recalls: Recalls;
	t: any;
}
